export const DEFAULT_SUBDOMAIN: string = process.env.DEFAULT_SUBDOMAIN
export const DEFAULT_TENANT: string = process.env.DEFAULT_TENANT
